import React, { useEffect, useRef, useCallback } from 'react';
import { Route, withRouter } from 'react-router-dom';
import { Modal } from 'antd';
import Header from './tpl/Header';
import Leftnavs from './tpl/Leftnavs';
import Footer from './tpl/Footer';
import util from '../../utils/util';

const IDLE_TIMEOUT  = 60 * 60 * 1000; // 1 hour
const WARN_BEFORE   =  1 * 60 * 1000; //  1 minute warning

function Default(props) {
    const { component: Component, history, ...rest } = props;

    const idleTimer   = useRef(null);
    const warnTimer   = useRef(null);
    const warnShown   = useRef(false);

    const doLogout = useCallback(() => {
        Modal.destroyAll();
        util.logout(null, history);
    }, [history]);

    const resetTimers = useCallback(() => {
        clearTimeout(idleTimer.current);
        clearTimeout(warnTimer.current);
        warnShown.current = false;

        // Warn 1 min before logout
        warnTimer.current = setTimeout(() => {
            if (warnShown.current) return;
            warnShown.current = true;
            Modal.warning({
                title: 'Session Expiring',
                content: 'You will be logged out in 1 minute due to inactivity. Move your mouse or press a key to stay logged in.',
                okText: 'Stay Logged In',
                onOk: resetTimers,
            });
        }, IDLE_TIMEOUT - WARN_BEFORE);

        // Auto logout after full idle period
        idleTimer.current = setTimeout(() => {
            Modal.destroyAll();
            Modal.error({
                title: 'Session Expired',
                content: 'You have been logged out due to inactivity.',
                onOk: doLogout,
            });
            doLogout();
        }, IDLE_TIMEOUT);
    }, [doLogout]);

    useEffect(() => {
        // Check force_password_change on every route render
        const forced = localStorage.getItem('force_password_change');
        if (forced === '1' && !window.location.pathname.includes('/profile')) {
            history.push('/profile?force=1');
            return;
        }

        // Activity events that reset idle timer
        const events = ['mousemove','mousedown','keydown','scroll','touchstart','click'];
        events.forEach(e => window.addEventListener(e, resetTimers, { passive: true }));
        resetTimers();

        return () => {
            events.forEach(e => window.removeEventListener(e, resetTimers));
            clearTimeout(idleTimer.current);
            clearTimeout(warnTimer.current);
        };
    }, [resetTimers, history]);

    return (
        <Route {...rest} render={() => (
            <>
                <Header {...rest} />
                
                <div className="page-container">
                    <div className="page-content-wrapper">
                        <Leftnavs {...rest} />
                        <Component {...rest} />
                    </div>
                </div>
                <Footer />
            </>
        )} />
    );
}

export default withRouter(Default);
